/**
 * Renders the markdown subset used in ticket threads (same syntax as the
 * admin composer): links, **bold**, *italic*, __underline__, `code`, and
 * line breaks. Escapes raw HTML first so unmatched markup cannot inject XSS.
 */
export const parseTicketMessageHtml = (text: unknown): string => {
    if (!text && text !== '') return ''

    const escapeHTML = (str: string) =>
        String(str)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;')

    const decodeHTMLEntities = (str: string) =>
        String(str)
            .replace(/&amp;/g, '&')
            .replace(/&quot;/g, '"')
            .replace(/&#39;/g, "'")
            .replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>')

    const sanitizeUrl = (href: string) => {
        const decoded = decodeHTMLEntities(String(href || '').trim())
        const lower = decoded.toLowerCase()
        if (lower.startsWith('http://') || lower.startsWith('https://')) {
            return escapeHTML(decoded)
        }
        return '#'
    }

    const normalized = String(text).replace(/<br\s*\/?>/gi, '\n')
    let safe = escapeHTML(normalized)

    safe = safe.replace(/\[([^\]]+)\]\(([^)]+)\)/g, (_match, label: string, href: string) => {
        const safeHref = sanitizeUrl(href)
        return `<a href="${safeHref}" target="_blank" rel="noopener noreferrer nofollow" style="color: inherit; text-decoration: underline;">${label}</a>`
    })

    safe = safe.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
    safe = safe.replace(/(?<!\*)\*(?!\*)([^*]+)(?<!\*)\*(?!\*)/g, '<em>$1</em>')
    safe = safe.replace(/__(.*?)__/g, '<u>$1</u>')
    safe = safe.replace(
        /`([^`]+)`/g,
        '<code style="background-color: #f0f0f0; padding: 2px 4px; border-radius: 3px; font-family: monospace;">$1</code>'
    )

    return safe.replace(/\n/g, '<br/>')
}
